export default class Tabs {
  constructor(elem) {
    this.triggers = elem.querySelectorAll('.js-tab-trigger');
    this.tabs = elem.querySelectorAll('.js-tab-content');

    if (!this.triggers.length || !this.tabs.length) {
      return;
    }

    this.activeTabId = false;

    this.handleClick = this.handleClick.bind(this);

    this.setDOMReferences();
  }

  setDOMReferences() {
    for (let i = 0; i < this.triggers.length; i++) {
      const element = this.triggers[i];
      const { tabId, type } = element.dataset;

      if (element.classList.contains('is--active')) {
        this.activeTabId = tabId;
      }

      if (tabId) {
        element.addEventListener('click', () => this.handleClick(tabId, type));
      }
    }
  }

  handleClick(id, type) {
    for (let i = 0; i < this.triggers.length; i++) {
      const element = this.triggers[i];
      const { tabId } = element.dataset;
      const isCurrent = tabId === id;

      if (isCurrent) {
        if (type === 'accordion' && element.classList.contains('is--active')) {
          element.classList.remove('is--active');
        } else {
          element.classList.add('is--active');
        }
      } else if (type === 'tab') {
        element.classList.remove('is--active');
      }
    }

    for (let i = 0; i < this.tabs.length; i++) {
      const element = this.tabs[i];
      const { tabId } = element.dataset;
      const isCurrent = tabId === id;

      if (isCurrent) {
        if (type === 'accordion' && element.classList.contains('is--active')) {
          element.classList.remove('is--active');
        } else {
          element.classList.add('is--active');
        }
      } else if (type === 'tab') {
        element.classList.remove('is--active');
      }
    }

    this.activeTabId = id;
  }
}
